import { useAppSelector } from '@/shared/hooks';

import { organizationModel } from '@/entities/organization';

import { GpFDAReport } from '../GpFDAReport';
import { GpReport } from '../GpReport';

export const CBCTGPReportContainer = () => {
  const { isFDA } = useAppSelector(
    organizationModel.selectors.selectFDAEnvironment,
  );

  return isFDA ? <GpFDAReport /> : <GpReport />;
};
